module.exports = __webpack_public_path__ + "static/media/camera.60fe3258.svg";